import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import appointmentService from "../../services/appointmentService";

const AppointmentAssignModal = (props) => {
  const { appointmentId, attorneyId, refreshMonth } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const assignToMeAppt = () => {
    const appt = { appointmentId: appointmentId, userId: attorneyId };
    appointmentService.attorneyAssignToMe(appt).then(() => {
      refreshMonth();
      toggle();
    });
  };

  return (
    <div className="mt-auto">
      <Button onClick={toggle} style={{ width: "45%" }} color="success">
        Assign to me!
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Assign appointment to me</ModalHeader>
        <ModalBody>Are you sure you want to accept this appointment?</ModalBody>
        <ModalFooter>
          <Button color="success" onClick={assignToMeAppt}>
            Assign to me!
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AppointmentAssignModal;
